import { render, staticRenderFns } from "./settlementdialog.vue?vue&type=template&id=5579bb07&scoped=true&"
import script from "./settlementdialog.vue?vue&type=script&lang=js&"
export * from "./settlementdialog.vue?vue&type=script&lang=js&"
import style1 from "./settlementdialog.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5579bb07",
  null
  
)

export default component.exports